import ms from 'ms';
import { type ContainerInstance, Service } from 'typedi';
import { z } from 'zod';
import { LocalStorageService } from './local-storage';

export const appSettingsSchema = z
  .object({
    enableI18nLogging: z.boolean().default(false),
    enableOktaLogging: z.boolean().default(false),
    enableReduxChecks: z.boolean().default(false),
    enableReduxDevTools: z.boolean().default(false),
    enableReduxSagaLogging: z.boolean().default(false),
    loginMaxAgeSeconds: z.number().default(ms('40h') / ms('1s')),
    simulateCrashOnLoad: z.boolean().default(false),
    simulateCrashOnNavigate: z.boolean().default(false),
  })
  .strict();

export type AppSettings = z.infer<typeof appSettingsSchema>;

export const SETTINGS_KEY = 'ccm/prayer-stream/settings';

@Service()
export class SettingsService {
  readonly settings: AppSettings;

  constructor(container: ContainerInstance) {
    this.settings = appSettingsSchema.parse({});
    const storage = container.get(LocalStorageService).localStorage;

    const savedSettings = storage.getItem(SETTINGS_KEY);
    if (savedSettings) {
      let overrides: unknown;
      try {
        overrides = JSON.parse(savedSettings);
      } catch {
        console.warn(`[Settings] Malformed JSON in ${SETTINGS_KEY}`);
      }
      const result = appSettingsSchema.safeParse(overrides);
      if (result.error) {
        console.warn(z.prettifyError(result.error));
      } else {
        this.settings = result.data;
      }
    }
  }
}
